var lib_core = require("lib-core");
var jquery = require("jquery");

if(typeof window !== 'undefined')
    require("jquery.browser");

var EnvironmentTesterModel = function (options) {
    var self = this;
    lib_core.Model.call(this);

    this.showBanner = this.value("showBanner", true);
    if(typeof window !== 'undefined')
        this.showBanner(!jquery.browser.chrome);
};
lib_core.inherit(EnvironmentTesterModel, lib_core.Model);
EnvironmentTesterModel.$class = "EnvironmentTesterModel";

module.exports = EnvironmentTesterModel;
